import { Injectable } from '@angular/core';
import { ImplementerEditor, ImplementerSnapshotSummary } from '../../models/implementer/implementer.models';
import { PtLuxonDate } from '../../models/projects/date.models';
import { CompleteDayEditor } from '../../models/complete-day.models';
import { TimeZoneService } from '../time-zone/time-zone.service';
import { DateService } from '../date/date.service';

@Injectable()
export class ImplementerDateService {

  constructor(
    private timeZoneService: TimeZoneService,
    private dateService: DateService,
  ) {
  }

  public async setImplementerEditorLocalDates(summary: ImplementerEditor): Promise<ImplementerEditor> {
    if (summary.latestDate) {
      summary.latestDate = await this.dateService.setPtLuxonDateFromApi(summary.latestDate);
    }

    if (summary.minLockableDate) {
      summary.minLockableDate = await this.dateService.setPtLuxonDateFromApi(summary.minLockableDate);
    }

    if (summary.maxLockableDate) {
      summary.maxLockableDate = await this.dateService.setPtLuxonDateFromApi(summary.maxLockableDate);
    }

    if (summary.sjhSuggestedMaxLockableDate) {
      summary.sjhSuggestedMaxLockableDate = await this.dateService.setPtLuxonDateFromApi(summary.sjhSuggestedMaxLockableDate);
    }

    if (summary.startDate) {
      summary.startDate = await this.dateService.setPtLuxonDateFromApi(summary.startDate);
    } else {
      summary.startDate = new PtLuxonDate();
    }

    if (summary.endDate) {
      summary.endDate = await this.dateService.setPtLuxonDateFromApi(summary.endDate);
    } else {
      summary.endDate = new PtLuxonDate();
    }

    return summary;
  }

  public async setImplementerSnapshotSummaryLocalDates(summary: ImplementerSnapshotSummary): Promise<ImplementerSnapshotSummary> {
    if (!summary) {
      return null;
    }

    if (summary.startDate) {
      summary.startDate = await this.dateService.setPtLuxonDateFromApi(summary.startDate);
      summary.startDateToShow = summary.startDate.dateTime.toFormat('dd/MM/yyyy');
    }

    if (summary.endDate) {
      summary.endDate = await this.dateService.setPtLuxonDateFromApi(summary.endDate);
      summary.endDateToShow = summary.endDate.dateTime.toFormat('dd/MM/yyyy');
    }

    if (summary.creationTime) {
      summary.creationTime = await this.dateService.setPtLuxonDateFromApi(summary.creationTime);
      summary.activationDateToShow = summary.creationTime.dateTime.toFormat('dd/MM/yyyy');
    }

    if (summary.mergeDate && summary.mergeDate.dateTime) {
      summary.mergeDate = await this.dateService.setPtLuxonDateFromApi(summary.mergeDate);
      summary.mergeDateToShow = summary.mergeDate.dateTime.toFormat('dd/MM/yyyy HH:mm');
    }

    if (summary.cancellationDate && summary.cancellationDate.dateTime) {
      summary.cancellationDate = await this.dateService.setPtLuxonDateFromApi(summary.cancellationDate);
    }

    return summary;
  }

  public async setCompleteDayEditorLocalDates(editors: CompleteDayEditor[]): Promise<CompleteDayEditor[]> {
    for (let i = 0; i < editors.length; i++) {
      if (editors[i].ptLuxonDate) {
        editors[i].ptLuxonDate = await this.dateService.setPtLuxonDateFromApi(editors[i].ptLuxonDate);
      }
    }

    return editors;
  }
}



// WEBPACK FOOTER //
// ./src/services/implementer/implementer-date.service.ts